import { render, staticRenderFns } from "./LangButton.vue?vue&type=template&id=2dbf1d90"
import script from "./LangButton.vue?vue&type=script&lang=js"
export * from "./LangButton.vue?vue&type=script&lang=js"
import style0 from "./LangButton.vue?vue&type=style&index=0&id=2dbf1d90&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports